module.exports = __webpack_public_path__ + "img/1064997178.967baf29.png";